import { render, staticRenderFns } from "./Festivals.vue?vue&type=template&id=6483462c&scoped=true&"
import script from "./Festivals.vue?vue&type=script&lang=js&"
export * from "./Festivals.vue?vue&type=script&lang=js&"
import style0 from "./Festivals.vue?vue&type=style&index=0&id=6483462c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6483462c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VFlex,VLayout})
